import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

interface Props {
  rows: any[];
}

const MonthViewTable = ({ rows }: Props) => {
  const tableheaders = [
    { id: 0, KEY: "Period", label: "Period", sortable: true },
    { id: 1, KEY: "Target", label: "Forecast", sortable: true },
    { id: 2, KEY: "Actual", label: "Actual", sortable: true },
    { id: 3, KEY: "Deviation", label: "Deviation", sortable: true },
  ];
  const sortedRows = rows || [];

  const allValuesNull = sortedRows.every(
    (row: any) =>
      (row.Actual === null || row.Actual === "") &&
      (row.Target === null || row.Target === "") &&
      (row.Deviation === null || row.Deviation === "")
  );

  const selectedMetric = useSelector((state: any) => state.forecasters?.selectedMetric);

  const isPercentageMetric = () => {
    const percentageMetrics = ['growth', 'cvr', 'avg_rs_p', 'churn_rate', 'rs_br_ng', 'ratio_between_acquired_to_ftd'];
    return percentageMetrics.includes(selectedMetric?.toLowerCase());
  };

  const formatValue = (value: any) => {
    if (value === null || value === "" || isNaN(value)) return "0";
    return isPercentageMetric()  ? `${Math.round(Number(value) * 100)}%` : Math.round(Number(value));
  };

  return (
    <>
      <TableContainer sx={{ maxHeight: 162, scrollbarWidth: "thin" }}>
        <Table aria-label="collapsible table" size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {tableheaders.map((header, index) => (
                <TableCell key={index} align="left">
                  {header.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {allValuesNull ? (
              <TableRow>
                <TableCell colSpan={tableheaders.length} align="center">
                  <Typography variant="h6">No data available</Typography>
                </TableCell>
              </TableRow>
            ) : (
              sortedRows.map((row: any, rowIndex: any) => (
                <React.Fragment key={rowIndex}>
                  <TableRow
                    sx={{
                      "& > *": { borderBottom: "1px solid rgba(224, 224, 224, 1) !important" },
                    }}
                  >
                    <TableCell align="left">
                      {row?.Period.replace(/_/g, " ").replace(/\b\w/g, (char: any) => char.toUpperCase())}
                    </TableCell>
                    <TableCell align="left">
                      {formatValue(row?.Target)}
                    </TableCell>
                    <TableCell align="left">
                      {formatValue(row?.Actual)}
                    </TableCell>
                    <TableCell align="left">
                      {`${Math.round(Number(row?.Deviation * 100))}%`}
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default MonthViewTable;
